import { axiosService } from '..';

export default class EnableBusinessFrontPageSlugService {
    public async execute(businessId: number): Promise<boolean> {
        return (await axiosService.instance.post(`businesses/organization/front-page/${businessId}/enable-slug`)).data;
    }
}

export const enableBusinessFrontPageSlugService = new EnableBusinessFrontPageSlugService();
